import { useDisclosure } from "@chakra-ui/react";
import { useRef } from "react";

export const useHelpBanner = () => {
    // HelpBanner
  const helpBtnRef = useRef<HTMLButtonElement>(null);
    const { isOpen: helpIsOpen, onOpen: helpOnOpen, onClose: helpOnClose } = useDisclosure();
    
    return {helpBtnRef, helpIsOpen, helpOnOpen, helpOnClose}
};